import React, { Component } from 'react';
import {inject, observer} from 'mobx-react';
import {reaction, autorun} from 'mobx';
import Lottie from 'react-lottie';
import * as animationData from '../static-json/loading.json';
import * as moment from 'moment';
import StateDropdown from './stateDropdown';
import { CSSTransition } from 'react-transition-group';

//ad

@inject ('RootStore')
@observer class WizardApp extends Component {


  //General Constructor Function
  constructor(props) {
    super(props);
    this.state = {isStopped: false, isPaused: false};
    this.paginate = this.paginate.bind(this);
    autorun(() => {
      //If step four, loading up, wait for response to unset loading
      const {RootStore} = this.props;
      if(RootStore.globalPropsStore.wizardProps.imagesLoaded === false){
        RootStore.globalPropsStore.getAllWizardImages();
      }
    });
  }

  //Paginates the Carousel forward or backward
  // accepts event, and forward argument
  paginate =(e, forward=true)=>{
    const {RootStore} = this.props;
    if(!forward){
      RootStore.globalPropsStore.updateProp('isForward', false);
      RootStore.globalPropsStore.paginate();
    }else{
      RootStore.globalPropsStore.updateProp('isForward', true);
      RootStore.globalPropsStore.paginate();
    }
  }

  //Wizard step indicator
  wizardSteps=()=>{
    const {RootStore} = this.props;
    return (
      <>
        {RootStore.globalPropsStore.wizardProps.wizardStep != 4 &&
          <div className="wizardApp__steps">
            <div className={RootStore.globalPropsStore.wizardProps.wizardStep == 1 ? 'isActive' : RootStore.globalPropsStore.wizardProps.wizardStateValue ? 'isSufficed' : ''}>1</div>
            <div><span className="visuallyHidden">-</span></div>
            <div className={RootStore.globalPropsStore.wizardProps.wizardStep == 2 ? 'isActive' : RootStore.globalPropsStore.wizardProps.isRegistered ? 'isSufficed' : ''}>2</div>
            <div><span className="visuallyHidden">-</span></div>
            <div className={RootStore.globalPropsStore.wizardProps.wizardStep == 3 ? 'isActive' : ''}>3</div>
          </div>
        }
      </>
    )
  }

  //Update a prop in the rootstore
  //Parsing function to pull out text and property from a button
  updateProp=(e)=>{
    const {RootStore} = this.props;
    let {value, name} = e.target;
    RootStore.globalPropsStore.updateProp(name, value);
  }

  checkStep =(step)=>{
    const {RootStore} = this.props;
    if(step === RootStore.globalPropsStore.wizardProps.wizardStep){
      return true;
    }else{
      return false;
    }
  }

  //Render Function
  render() {
    //Pull the root store from application props
    const {RootStore} = this.props;

    //Scope of this for closures
    const _this = this;

    //Lottie settings as a ...
    const lottieOptions = {
      loop: true,
      autoplay: true,
      animationData: animationData.default,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    };

    //Return all
    return (
      <>
      {!RootStore.globalPropsStore.wizardProps.imagesLoaded &&
        <div className="wizardAppContainer">
          <div className="wizard__slide wizard__slide--isActive">
            {/*LOADING*/}
            <>
              <div className="colB wizard__loading">
                <h4 className="wizard__heading text-center">loading your personalized voting planner</h4>
                <div>
                <Lottie options={lottieOptions}
                    height={300}
                    width={300}
                    isStopped={this.state.isStopped}
                    isPaused={this.state.isPaused}/>
                </div>
              </div>
            </>
          </div>
        </div>
      }
      {RootStore.globalPropsStore.wizardProps.imagesLoaded &&
        <div className="wizardAppContainer">
          <CSSTransition in={this.checkStep(1)} timeout={200} classNames="wiz-slide-anim" unmountOnExit>
            <div className="wiz-slide-anim">
              <div className='wizard__slide'>
                  <div className="colA">
                    <div className="hide-for-large">{this.wizardSteps()}</div>
                    {!RootStore.globalPropsStore.wizardProps.imagesLoaded &&
                      <img src={"http://placehold.it/118x325"} alt="step image"/>
                    }
                    {RootStore.globalPropsStore.wizardProps.imagesLoaded &&
                      <img src={RootStore.globalPropsStore.wizardImages.step_one_image.url} alt={RootStore.globalPropsStore.wizardImages.step_one_image.alt} />
                    }
                  </div>
                  <div className="colB">
                    <div className="show-for-large">{this.wizardSteps()}</div>
                    <h4 className="wizard__heading">In the upcoming election, where are you planning to vote?</h4>
                    <StateDropdown/>
                    <div className="wizard__buttons wizard__buttons--small-left">
                      <button className="button__full" onClick={(e) => this.paginate(e)} disabled={!RootStore.globalPropsStore.wizardProps.wizardStateValue ? true : false}>Next </button>
                    </div>
                  </div>
              </div>
            </div>
          </CSSTransition>
          <CSSTransition in={this.checkStep(2)} timeout={200} classNames="wiz-slide-anim" unmountOnExit>
            <div className="wiz-slide-anim">
              <div className='wizard__slide'>
              <div className="colA">
                <div className="hide-for-large">{this.wizardSteps()}</div>
                {!RootStore.globalPropsStore.wizardProps.imagesLoaded &&
                  <img src={"http://placehold.it/118x325"} alt="step image"/>
                }
                {RootStore.globalPropsStore.wizardProps.imagesLoaded &&
                  <img src={RootStore.globalPropsStore.wizardImages.step_two_image.url} alt={RootStore.globalPropsStore.wizardImages.step_two_image.alt} />
                }
              </div>
              <div className="colB">
                <div className="show-for-large">{this.wizardSteps()}</div>
                <h4 className="wizard__heading">Are you already registered to vote with your current address in {RootStore.globalPropsStore.wizardProps.wizardStateName}?</h4>
                <div className="wizardApp__radio-group">
                  <input type="radio" id="yes" name="isRegistered" value="1" onChange={this.updateProp} checked={RootStore.globalPropsStore.wizardProps.isRegistered == 1 ? true : false}/>
                  <label htmlFor="yes">Yes</label>
                  <input type="radio" id="notYet" name="isRegistered" value="2" onChange={this.updateProp} checked={RootStore.globalPropsStore.wizardProps.isRegistered == 2 ? true : false}/>
                  <label htmlFor="notYet">Not Yet</label>
                  <input type="radio" id="notSure" name="isRegistered" value="3" onChange={this.updateProp} checked={RootStore.globalPropsStore.wizardProps.isRegistered == 3 ? true : false}/>
                  <label htmlFor="notSure">I'm Not Sure</label>
                </div>
                <div className="wizard__buttons">
                  <button className="button__text" onClick={(e) => this.paginate(e, false)}>&larr; Back</button>
                  <button className="button__full" onClick={(e) => this.paginate(e)} disabled={!RootStore.globalPropsStore.wizardProps.isRegistered ? true : false}>Next </button>
                </div>
              </div>
              </div>
            </div>
          </CSSTransition>
          <CSSTransition in={this.checkStep(3)} timeout={200} classNames="wiz-slide-anim" unmountOnExit>
            <div className="wiz-slide-anim">
              <div className='wizard__slide'>
              <div className="colA">
                <div className="hide-for-large">{this.wizardSteps()}</div>
                {!RootStore.globalPropsStore.wizardProps.imagesLoaded &&
                  <img src={"http://placehold.it/118x325"} alt="step image"/>
                }
                {RootStore.globalPropsStore.wizardProps.imagesLoaded &&
                  <img src={RootStore.globalPropsStore.wizardImages.step_three_image.url} alt={RootStore.globalPropsStore.wizardImages.step_three_image.alt} />
                }
              </div>
              <div className="colB">
                <div className="show-for-large">{this.wizardSteps()}</div>
                <h4 className="wizard__heading">What method are you planning to use to vote?</h4>
                <div className="wizardApp__radio-group">
                  <input type="radio" id="pollingPlace" name="voteMethod" value="1" onChange={this.updateProp} checked={RootStore.globalPropsStore.wizardProps.voteMethod == 1 ? true : false}/>
                  <label htmlFor="pollingPlace">at a polling place</label>
                  <input type="radio" id="mail" name="voteMethod" value="2" onChange={this.updateProp} checked={RootStore.globalPropsStore.wizardProps.voteMethod == 2 ? true : false}/>
                  <label htmlFor="mail">by mail</label>
                  <input type="radio" id="notSureMethod" name="voteMethod" value="3" onChange={this.updateProp} checked={RootStore.globalPropsStore.wizardProps.voteMethod == 3 ? true : false}/>
                  <label htmlFor="notSureMethod">I'm Not Sure</label>
                </div>
                <div className="wizard__buttons">
                  <button className="button__text" onClick={(e) => this.paginate(e, false)}>&larr; Back</button>
                  <button className="button__full" onClick={(e) => this.paginate(e)} disabled={!RootStore.globalPropsStore.wizardProps.voteMethod ? true : false}>Next </button>
                </div>
              </div>
              </div>
            </div>
          </CSSTransition>
          <CSSTransition in={RootStore.globalPropsStore.wizardProps.isLoading} timeout={200} classNames="wiz-slide-anim" unmountOnExit>
            <div className="wiz-slide-anim">
              <div className='wizard__slide'>
                {/*LOADING*/}
                <>
                  <div className="colB wizard__loading">
                    <h4 className="wizard__heading text-center">loading your personalized voting plan</h4>
                    <div>
                    <Lottie options={lottieOptions}
                        height={300}
                        width={300}
                        isStopped={this.state.isStopped}
                        isPaused={this.state.isPaused}/>
                    </div>
                  </div>
                </>
              </div>
            </div>
          </CSSTransition>
          <CSSTransition in={RootStore.globalPropsStore.wizardProps.isFinal} timeout={200} classNames="wiz-slide-anim" unmountOnExit>
            <div className="wiz-slide-anim">
              <div className='wizard__slide'>
                <div className="colB text-left">
                  <div className="wizard__illustration">
                    {!RootStore.globalPropsStore.wizardProps.imagesLoaded &&
                      <img width="100%" height="auto" src="http://placehold.it/800x300" alt="final-illustration"/>
                    }
                    {RootStore.globalPropsStore.wizardProps.imagesLoaded &&
                      <img src={RootStore.globalPropsStore.wizardImages.end_image.url} alt={RootStore.globalPropsStore.wizardImages.end_image.alt} />
                    }
                  </div>
                  <h4 className="wizard__heading">Hot off the press: Your personalized plan for the 2024 Election!</h4>
                  <div className="wizard__list-parent">
                    <h4 className="wizard__list-heading text-left">Start Here</h4>
                    <div className="article__content">
                      <ul>
                        {RootStore.globalPropsStore.wizardProps.isRegistered == 1 &&
                          <li><strong>Task One:</strong> <a href="/register/check-your-registration/">Check Your Registration</a></li>
                        }
                        {RootStore.globalPropsStore.wizardProps.isRegistered == 2 &&
                          <li><strong>Task One:</strong> <a href="/register/">Get Registered</a></li>

                        }
                        {RootStore.globalPropsStore.wizardProps.isRegistered == 3 &&
                          <li><strong>Task One:</strong> <a href="/register/check-your-registration/">Check Your Registration</a></li>
                        }
                        <li><strong>Task Two:</strong> <a href="/take-the-pledge/">Take The Pledge</a></li>
                      </ul>
                    </div>
                    <hr/>
                    <h4 className="wizard__list-heading text-left">Mark Your Calendar</h4>
                    <div className="article__content">
                      <ul>
                        {/* <li><strong>{RootStore.globalPropsStore.wizardProps.wizardStateName} Registration Deadline:</strong> {RootStore.globalPropsStore.wizardProps.registrationData}</li> */}
                        {RootStore.globalPropsStore.electionResults.map((election, index) => (
                          <li key={index}><strong>{election.name}:</strong> {moment(election.election_day).format('MMM Do YYYY')}</li>
                        ))}
                      </ul>
                    </div>
                    <hr/>
                    <h4 className="wizard__list-heading text-left">What to Expect on Election Day</h4>
                    <div>
                      <ul className="half-list">
                        {RootStore.globalPropsStore.wizardProps.voteMethod == 1 &&
                          <>
                            <li><a target="_blank" className="waypoint-link" href={`https://www.vote.org/state/` + RootStore.globalPropsStore.wizardProps.wizardStateName.toLowerCase().replace(' ', '-') }>Voting Rules in {RootStore.globalPropsStore.wizardProps.wizardStateName}</a></li>
                            <li><a className="waypoint-link" href="/plan/request-your-ballot/">Request your Ballot </a></li>
                          </>
                        }
                        {RootStore.globalPropsStore.wizardProps.voteMethod == 2 &&
                          <>
                            {/* <li><a className="waypoint-link"  href="#">Read about Vote By Mail in {RootStore.globalPropsStore.wizardProps.wizardStateName} </a></li> */}
                            <li><a className="waypoint-link"  href="/learn_articles/how-do-i-vote-by-mail/">How do I vote Absentee? </a></li>
                          </>

                        }
                        {RootStore.globalPropsStore.wizardProps.voteMethod == 3 &&
                          <>
                            <li><a className="waypoint-link"  href="/learn_articles/can-i-vote-remotely/">Can I Vote Remotely? </a></li>
                            <li><a className="waypoint-link"  href="/learn_articles/how-do-i-vote-early/">How do I Vote Early? </a></li>
                            <li><a className="waypoint-link"  href="/learn_articles/how-do-i-vote-by-mail/">How do I Vote Absentee? </a></li>
                          </>
                        }
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </CSSTransition>
        </div>
      }
      </>
    );
  }

}

export default WizardApp;
